import React           from 'react';
import Unit            from './Unit';

import { appsType }    from '../../types';

import colors          from '../../utils/colors';
import { makeStyles }  from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    container: {
      position:     'absolute',
      left:         0,
      top:          200,
      overflowY:    'scroll',
      overflowX:    'hidden',
      borderTop:    '1px solid #DDD',
      '&::-webkit-scrollbar': {
        width: '0.5em',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: colors.dark,
        borderRadius:    10
      }
    },
    grid: {
      display:    'grid',
      marginRight: '50%',
      transform:  'translate(50%, 0)',
      width:      '100%',
    }
}))

type AppsGridProps = {
  width:                  number;
  size:                   number[];
  lang:                   string;
  variant:                string;
  userRole:               string;
  appsArr:                appsType[];
  handleAppClick:         (val: number) => void;
  handleStudentInfoClick: (val: string[]) => void;
}

const AppsGrid: React.FC<AppsGridProps> = ({
  width,
  size,
  lang,
  variant,
  userRole,
  appsArr,
  handleAppClick,
  handleStudentInfoClick
}) => {

  const classes = useStyles();

  const containerStyle = React.useMemo(() => {
    return {
      height: size[1] - 200,
      width:  width
    }
  },[size, width])


  const gridStyle = React.useMemo(() => {
    return {
      gridTemplateColumns: `repeat(${ size[0] > 1200 ? 3 : ( size[0] > 800 ? 2 : 1) }, 1fr)`,
      maxWidth:            size[0] > 1200 ? 930 : 620,
    }
  },[size])


  return (
         <div 
            className = { classes.container }
            style     = { containerStyle }
            dir       = 'rtl'
         >
            <div 
              className = { classes.grid }
              style     = { gridStyle }
            >
            {
                appsArr.map((val, ind) => {
                    return(
                        <Unit
                           key                    = { `row_${ ind }` }
                           ind                    = { ind }
                           val                    = { val }
                           variant                = { variant }
                           lang                   = { lang }
                           userRole               = { userRole }
                           handleAppClick         = { handleAppClick }
                           handleStudentInfoClick = { handleStudentInfoClick }
                        />
                    )
                })
            }
            </div>
         </div>
  );
}

export default AppsGrid;





